import { Star } from '@/components/Icons/Star'

interface ILeaderboardTableCellProps {
  position: number
  name: string
  institution: string
  points: number
  isLast?: boolean
}

const LeaderboardTableCell = ({
  position,
  name,
  institution,
  points,
  isLast = false,
}: ILeaderboardTableCellProps) => {
  return (
    <div
      className={`w-full flex justify-between items-center px-7 py-5 ${
        !isLast ? 'border-b border-neutral-400' : ''
      }`}
    >
      <div className="flex gap-x-7 items-center">
        <p className="text-[24px] font-bold">{position}</p>
        <div className="flex flex-col">
          <p className="text-[24px] font-bold">{name}</p>
          <p className="text-xs">{institution}</p>
        </div>
      </div>
      <div className="text-neutral-600 text-[24px] font-bold flex items-center">
        <Star className="mr-1" /> {points} points
      </div>
    </div>
  )
}

export default LeaderboardTableCell